export const GraphColourArray = [
  "#00475A",
  "#91C840",
  "#097896",
  "#DBE794",
  "#E37B17",
  "#E3D317",
  "#6D6E71",
  "#F9CB10",
  "#ed432c",
  "#006782",
  "#325765",
  "#db944f",
  //   "#FFF",
  //   "#9c7c5d",
  //   "#c9a581",
  //   //   "#00475A",
  //   //   "#00475A",
  //   //   "#00475A",
  //   //   "#00475A",
  //   //   "#00475A",
];



// WEBPACK FOOTER //
// ./src/app/common/enums/GraphColours.ts